import { useState } from 'react';
// see Accordion.stories.tsx for example implementation
export const Accordion = ({ render, data, initialOpenPanels }) => {
    const [currentOpenPanels, setCurrentOpenPanels] = useState(initialOpenPanels || []);
    const isAllPanelsOpen = currentOpenPanels.length === data.length;
    const isPanelOpen = (index) => {
        return currentOpenPanels.includes(index);
    };
    const togglePanel = (index) => {
        if (isPanelOpen(index)) {
            setCurrentOpenPanels(currentOpenPanels.filter((i) => index !== i));
        }
        else {
            setCurrentOpenPanels([...new Set([...currentOpenPanels, index])]);
        }
    };
    const openPanels = (panels) => {
        setCurrentOpenPanels([...new Set([...currentOpenPanels, ...panels])]);
    };
    const closePanels = () => {
        setCurrentOpenPanels([]);
    };
    if (render) {
        return render({
            isPanelOpen,
            togglePanel,
            openPanels,
            closePanels,
            isAllPanelsOpen,
            currentOpenPanels,
            data,
        });
    }
    return null;
};
